import { UseFormReturn } from 'react-hook-form'
import { uploadPhoto } from '~/features/DocumentBasedRegistration/helpers'
import {
  FixButtonWrapper,
  FormWrapper,
} from '~/features/DocumentBasedRegistration/styled'
import { countriesOptions } from '~/shared/config/constants'
import { IdentityRecognitionFileEnum } from '~/shared/config/enums'
import { useTaxiparkQueryParams } from '~/shared/lib/useTaxiparkQueryParams'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider, Select, PickPhotos } from '~/shared/ui/form'
import { FormValues } from './model'
import { TemplateWrapper } from './styled'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
  isLoading: boolean
}

const photoConfig = [
  {
    title: 'Лицевая сторона ВУ',
    type: IdentityRecognitionFileEnum.driverLicenseFront,
  },
  {
    title: 'Обратная сторона ВУ',
    type: IdentityRecognitionFileEnum.driverLicenseBack,
  },
]

export function Form({ onSuccess, form, isLoading }: FormProps) {
  const { taxiparkIdQuery } = useTaxiparkQueryParams()

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <FormWrapper>
        <Select
          options={countriesOptions}
          name='drivingLicenseIssuingCountry'
          label='Страна выдачи'
          modalTitle='Страна выдачи'
          canSearch
        />

        <PickPhotos
          descriptions='Добавьте две фотографии водительского удостоверения: с лицевой и с обратной стороны'
          name='drivingLicensePhotos'
          multiple
          fnUpload={(file: Blob) => uploadPhoto(file, taxiparkIdQuery)}
          maxPhotos={2}
          photoConfig={photoConfig}
        />

        <TemplateWrapper>
          <img src='/images/DrivingLicenseFront.png' alt='' />
          <br />
          <img src='/images/DrivingLicenseBack.png' alt='' />
        </TemplateWrapper>

        <FixButtonWrapper>
          <Button
            loading={isLoading}
            variant='limeFlooded'
            size='large'
            type='submit'
            fullWidth
          >
            Продолжить
          </Button>
        </FixButtonWrapper>
      </FormWrapper>
    </FormProvider>
  )
}
